import React from "react";
import { FormHelperText, Typography } from "@mui/material";
import { TextField } from "@components/Input/Input.styles";
import { useTranslation } from "react-i18next";
import { usePortServicesFlow } from "../context/PortServicesFlowContext";
import { notesOnlySchema } from "../schemas/approvedByMDSludgeDisposalSchema";

const LANG_BASE = "vessel-call.port-services";

const NotesField = () => {
  const { t } = useTranslation();
  const { setNotes, notes, errors, setErrors } = usePortServicesFlow();

  const charCounterSx = {
    ml: 0,
    mt: 0.5,
    fontSize: 12,
    textAlign: "right",
    color: "text.secondary",
  };

  const isPrintableKey = (e: React.KeyboardEvent) =>
    e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey;
  const TEXTAREA_MAX_CHARS = 1000;

  return (
    <div className="flex flex-col gap-2" data-testid="port-services-notes">
      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
        {t(`${LANG_BASE}.fields.notes`)}
      </Typography>
      <TextField
        multiline
        minRows={4}
        value={notes}
        inputProps={{ maxLength: TEXTAREA_MAX_CHARS }}
        placeholder={t(`${LANG_BASE}.fields.notes`)}
        sx={{ "& textarea": { padding: "12px", borderRadius: "8px" } }}
        onKeyDown={(e: React.KeyboardEvent) => {
          if (!isPrintableKey(e)) return;
          if (notes.length >= TEXTAREA_MAX_CHARS) {
            setErrors({
              ...errors,
              notes: t("form-validation.max-length", {
                label: t(`${LANG_BASE}.fields.notes`),
                max: TEXTAREA_MAX_CHARS,
              }),
            });
          }
        }}
        onBlur={() => {
          const res = notesOnlySchema().safeParse({ notes });
          if (!res.success) {
            const flat = res.error.flatten().fieldErrors;
            setErrors({ ...errors, notes: flat.notes?.[0] });
          } else {
            setErrors({ ...errors, notes: undefined });
          }
        }}
        onChange={(e) => {
          const val = e.target.value;
          setNotes(val);
          const res = notesOnlySchema().safeParse({ notes: val });
          if (!res.success) {
            const flat = res.error.flatten().fieldErrors;
            setErrors({ ...errors, notes: flat.notes?.[0] });
          } else {
            setErrors({ ...errors, notes: undefined });
          }
        }}
      />
      {errors.notes && (
        <FormHelperText sx={{ color: "error.main", m: 0 }}>{errors.notes}</FormHelperText>
      )}
      <FormHelperText sx={charCounterSx}>
        {notes.length}/{TEXTAREA_MAX_CHARS}
      </FormHelperText>
    </div>
  );
};

export default NotesField;
